/** DOM helpers for saving files to the user's download folder. */

/**
 * Triggers a browser download for an already-resolved URL by clicking a
 * transient anchor. A presigned URL carrying a `Content-Disposition: attachment`
 * header makes the browser save the file (with its original name) straight to
 * the download folder instead of navigating to it.
 */
export function triggerBrowserDownload(url: string, fileName: string): void {
  const anchor = document.createElement('a')
  anchor.href = url
  anchor.download = fileName
  anchor.rel = 'noopener'
  document.body.appendChild(anchor)
  anchor.click()
  anchor.remove()
}

/**
 * Saves an in-memory Blob to the user's download folder via a temporary object
 * URL. Because the URL is same-origin, the browser honours the `download`
 * filename (unlike cross-origin S3 URLs).
 */
export function triggerBlobDownload(blob: Blob, fileName: string): void {
  const url = URL.createObjectURL(blob)
  triggerBrowserDownload(url, fileName)
  // Defer the revoke: revoking synchronously after click() can invalidate the
  // URL before Firefox/Safari start reading the blob, yielding a failed download.
  setTimeout(() => URL.revokeObjectURL(url), 0)
}
